





















































































import {Component, Emit, Prop, Vue} from "vue-property-decorator";
import { TagContentsParam } from "@/params/TagContentsParam";
import DialogCloseNavigation from "@/components/navigations/DialogCloseNavigation.vue";
import vuescroll from "vuescroll";

@Component({
  components: {
    DialogCloseNavigation,
    vuescroll
  }
})
export default class VrTagProductDialog extends Vue {
  protected isBannerHover: boolean = false;

  protected scrollOptions: any = {
    vuescroll: {
      detectResize: true
    },
    bar: {
      background: '#8A56AC'
    }
  };

  /* Property */
  @Prop() isShown: boolean;
  @Prop() contents: TagContentsParam;

  /* Computed Property */
  get publicPath (): string {
    return this.$store.state.publicPath;
  }

  get isSmp (): boolean {
    return this.$store.state.isSmp;
  }

  get parentDom (): HTMLDivElement {
    const $parent: HTMLDivElement = <HTMLDivElement> this.$parent.$el;
    return $parent;
  }

  get isShownDialog (): boolean {
    return this.isShown;
  }
  set isShownDialog (value: boolean) {
    if (!value) {
      this.onCloseDialog();
    }
  }

  get vScroll (): vuescroll {
    return <vuescroll> this.$refs.vScroll;
  }

  /* Emit Events */
  @Emit('close')
  onCloseDialog (): void {
    setTimeout(() => {
      this.vScroll.scrollTo({x: 0, y: 0}, 0);
    }, 300);
  }


  /* Event Handlers */
  protected onBannerHover (ev: MouseEvent): void {
    this.isBannerHover = true;
  }

  protected onBannerOut (ev: MouseEvent): void {
    this.isBannerHover = false;
  }
}
